<h2>{{ 'security.not_found.title' | translate }}</h2>
<p class="form-label">{{ currentPath }}</p>
<p>{{ 'security.not_found.description' | translate }}</p>
